export default {
  props: {
    date: { type: Date, required: true },
    path: { type: String, required: true },
  },
  computed: {
    day() {
      return this.date.getDate();
    },
    weekday() {
      // shift day by six, then cut off at 7
      // making sunday (0) to (6) -> (6)
      // or monday (1) to (7) -> (0)
      // so that weeks start at monday
      return (this.date.getDay() + 6) % 7;
    },
    month() {
      return this.date.getMonth() + 1;
    },
    year() {
      return this.date.getFullYear();
    },
    minutes() {
      return this.date.getMinutes();
    },
    hours() {
      return this.date.getHours();
    },
  },
};
